module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAAwCAYAAABDl2dmAAAA/klEQVRoge3ZsWnDUABF0SttkSZFlnC2SJ3OpbsUmcBbpMsMducRPEicBSyIKgWBRLAtPasKAt0DvxcX8RFPRdM0AO/deWDZauAAbIDvNs4a+Fx4lGtH4LkEXuf1XLOwAp7K7lXSrbqN8wE0xrmwB776C/kFeAMegWI+z/jvzt2FvAWqPo4GlEYZZ5zAOIFxAuMExgmMExgnME5gnMA4gXEC4wTGCfo47bh+6kavJZ8fYNf/aHBgH+bAHjiw3+HAPsKBfYAD+1R+5wTGCYwTGCcwTmCcwDiBcQLjBMYJjBMYJzBOYJzAgf3yOLBP4MAeOLDf4cA+woF9wN/ADtUvvNnIaSZFAmIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/menu.png
// module id = 175
// module chunks = 0